export default "__VITE_ASSET__DJNKqzqh__"